/* @flow */

import React, { useState, useCallback, useEffect } from 'react';
// import { TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import dayjs from 'dayjs';
import TextField from '@material-ui/core/TextField';

import l, { timeString } from '../utils/localization';


type Props = {
  currentDate: dayjs,
  onUpdateDate: (date: dayjs) => void,
  maxDate: dayjs,
  minDate: dayjs
}

const styles = {
  container: { backgroundColor: 'white', alignItems: 'center' },
};

const DELAY = 2000;

const InputLabelProps = {
  shrink: true,
};

const TimePicker = ({
  minDate, maxDate, currentDate, onUpdateDate,
}: Props) => {
  const [selectedDate, setSelectedDate] = useState(currentDate.format('HH:mm'));

  useEffect(() => {
    setSelectedDate(currentDate.format('HH:mm'));
  }, [currentDate]);

  const save = useCallback(() => {
    const [hours, minutes] = selectedDate.split(':'),
          date = dayjs().startOf('day').add(parseInt(hours, 10), 'hours').add(parseInt(minutes, 10), 'minutes');

    if (date.isValid()) {
      if ((!maxDate || date.valueOf() <= maxDate.valueOf())
      && (!minDate || date.valueOf() >= minDate.valueOf())) {
        onUpdateDate(date);
      } else {
        setSelectedDate(currentDate.format('HH:mm'));
        alert(`${l.pleaseSpecifyATimeBetween} ${minDate.format(timeString)} - ${maxDate.format(timeString)}`);
      }
    }
  }, [currentDate, maxDate, minDate, onUpdateDate, selectedDate]);

  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        save();
      }, DELAY);

      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [save], // Only re-call effect if value or delay changes
  );

  const onChange = (evt) => {
    setSelectedDate(evt.target.value);
  };

  const inputProps = {
    step: 300, // 5 min
    max: maxDate && maxDate.format('HH:mm'),
    min: minDate && minDate.format('HH:mm'),
  };

  return (
    <TextField
      type='time'
      value={selectedDate}
      onBlur={save}
      onChange={onChange}
      InputLabelProps={InputLabelProps}
      inputProps={inputProps}
    />
  );
};

export default TimePicker;
